var _defs, _path, _circle, _path2, _circle2, _path3, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconUiFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "icon_ui_filter_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 16 16"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_ui_filter_svg__cls-1{fill:none;stroke:#5f5d6d;stroke-miterlimit:10;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 13h9M1 13h2",
  className: "icon_ui_filter_svg__cls-1"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 13,
  r: 1.5,
  className: "icon_ui_filter_svg__cls-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 3h9M1 3h2",
  className: "icon_ui_filter_svg__cls-1"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 3,
  r: 1.5,
  className: "icon_ui_filter_svg__cls-1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 8H1M15 8h-2",
  className: "icon_ui_filter_svg__cls-1"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 8,
  r: 1.5,
  className: "icon_ui_filter_svg__cls-1"
})));
export default SvgIconUiFilter;